import { Box, Typography } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";

import { AppIcon } from "~/common/components/AppIcon/AppIcon";
import { PRODUCT_NAME } from "~/common/constants/brand";

export interface BrandWithIconProps {
  iconSize?: number;
  fontSize?: "sm" | "md" | "lg" | "xl";
  brandSx?: SxProps;
}

export const BrandWithIcon = ({
  iconSize = 32,
  fontSize = "lg",
  brandSx = {},
}: BrandWithIconProps) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <AppIcon width={iconSize} height={iconSize} />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: fontSize || { xs: "0.875rem", sm: "1.5rem" },
          textTransform: "uppercase",
          letterSpacing: "0.15em",
          ...brandSx,
        }}
      >
        {PRODUCT_NAME}
      </Typography>
    </Box>
  );
};
